import { canUseDOM } from "lib/helpers"
import { ISOCountryFactory } from "cookiesConsent/domain/ISOCountry"
import { currentGeo } from "cookiesConsent/infrastructure/edgeGeo/currentGeo"

const unitedStates = new ISOCountryFactory().fromString(`US`)

export const offersDataSaleOptOut = (): boolean =>
  canUseDOM && currentGeo().country.equals(unitedStates)
